import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import styles from './index.css';
import YouTube from 'react-youtube';
import {presets} from '../../stores/index';

export default class Landing extends Component {



    render() {
        return (
            <div>
                <div className={styles.youtubeContainer}>
                    <YouTube className={styles.video}
                             videoId="T8hxgjIOcZ0"
                             opts={
                                 {
                                     playerVars: {
                                         autoplay: 1,
                                         loop: 0,
                                         rel: 0,
                                         modestbranding: 1,
                                         showinfo: 0,
                                         controls: 0,
                                         start: 4
                                     }
                                 }
                             }
                             onReady={(e)=>{e.target.mute();this.setState({video:e.target})}}
                    />
                </div>
                <div className={styles.hoverWindow}>
                    <Link to={presets.gameCreate ? "/app" : "/"} className={styles.menuButton + (presets.gameCreate ? ' ' + styles.active : '')}>Продовжити симуляцію</Link>
                    <Link to="/elevatorbuild" className={styles.menuButton + ' ' + styles.active}>Нова симуляція</Link>
                    <a href="/logout" onClick={()=>fetch('/logout')} className={styles.menuButton + ' ' + styles.active}>Вийти</a>
                    {/*<Link to="/" className={styles.menuButton + ' ' + styles.active}>Завантажити симуляцію</Link>*/}
                    {/*<Link to="/" className={styles.menuButton + ' ' + styles.active}>Налаштування</Link>*/}
                    {/*<Link to="/login" className={styles.menuButton + ' ' + styles.active}>Вийти</Link>*/}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/shared/containers/Landing/index.js